import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-domain-not-found',
  templateUrl: './domain-not-found.component.html',
  styleUrls: ['./domain-not-found.component.scss']
})
export class DomainNotFoundComponent {

    domainPage:any;

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ){}
    ngOnInit(){
        this.route.queryParams.subscribe((queryParams) => {
            const rawDomain = queryParams.domain;

            if (rawDomain) {
              // Add protocol if missing to avoid URL constructor errors
              const url = new URL(`http://${rawDomain}`);
              this.domainPage = url.host;
            }
          });
    }

    redirectToDefaultPage(){
        this.router.navigate(['auth/login'])
    }

    register(){
        this.router.navigate(['auth/signup'])
    }
}
